<script>
	export let value;
	export let percentage;
	export let orders = null;
	export let difference = null;
	export let date = null;

	function formatValue(val) {
		const nFormat = new Intl.NumberFormat(undefined, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});

		const num = Number(val);
		return val == null || isNaN(num) ? '-' : nFormat.format(num);
	}
</script>

<section class="attribution-stats">
	<div class="stat">
		<p class="title">
			Attribution
			<span class="difference">{difference ? `${formatValue(difference)}%` : ''}</span>
		</p>
		<h2>
			{formatValue(value)}
		</h2>
		{#if date}
			<p class="info">{date}</p>
		{/if}
	</div>
	<span class="separator" />
	<div class="stat">
		<p
			class="
        title"
		>
			Attribution % <span class="difference">{difference ? `${formatValue(difference)}%` : ''}</span
			>
		</p>
		<h2>
			{formatValue(percentage)}%
		</h2>
		{#if orders}
			<p class="info">{formatValue(orders)} orders</p>
		{/if}
	</div>
</section>

<style>
	section {
		display: grid;
		grid-template-columns: 1fr 21px 1fr;
		gap: 24px;
		width: 100%;
	}
	.separator {
		display: block;
		height: 100%;
		border-right: 1px dashed #ddd;
	}
	.difference {
		margin-left: 2em;
		font-family: Inter;
		color: var(--Brand-Primary, #2fbfab);

		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		letter-spacing: 0.4px;
	}
	.attribution-stats .stat h2 {
		color: var(--Typography-Primary, #101828);
		font-family: Inter;
		font-size: 28px;
		font-style: normal;
		font-weight: 700;
		line-height: normal;
		letter-spacing: 0.28px;
		margin: 0.4em 0 0.2em;
	}
	.title {
		color: var(--Typography-Body, #2c2c31);
		font-family: Inter;

		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		letter-spacing: 0.16px;
	}
	.info {
		color: var(--Typography-Body, #2c2c31);
		font-family: Inter;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		letter-spacing: 0.14px;
	}
</style>
